


import React from 'react';
import axios from 'axios';
import { Button, TextField, Grid, Select, MenuItem} from '@material-ui/core';



export default class AlleviClientSupport extends React.Component {

    constructor() {
        super()

        this.handlePortFieldChange = this.handlePortFieldChange.bind(this)
        this.handleConnectClick = this.handleConnectClick.bind(this)
        this.handleCommandFieldChange = this.handleCommandFieldChange.bind(this)
        this.handleSendCommand = this.handleSendCommand.bind(this)
        this.handleStateRequest = this.handleStateRequest.bind(this)

        this.state = {
            port: 8000, 
            confirmedPort: "UNSET",
            connectionStatusMessage: "Status: Disconnected",  // determines if the port has been confirmed and validated
            connected: false,
            printerState: {},
            lastStateFetchTime: "",
            currentCommand: "",
            commandHistory: ""
        }
    }

    handlePortFieldChange(e) {
        this.setState({
          ...this.state,
          port: e.target.value
        });
      }

    async handleConnectClick() {

        if (this.state.connected) {
            this.setState({
                ...this.state,
                connected: false,
                connectionStatusMessage: "Status: Disconnected",
                confirmedPort: "UNSET",
                printerState: {},
                lastStateFetchTime: ""
              });
              return
        }

        
        try {
            const result = await axios.get(`http://127.0.0.1:${this.state.port}/ping`)

            if (result.status === 200) {
                this.setState({
                    ...this.state,
                    confirmedPort: this.state.port,
                    connectionStatusMessage: "Status: Connected on port " + this.state.port,
                    connected: true,
                  });
            } else {
                this.setState({
                    ...this.state,
                    connectionStatusMessage: "Did not receive a 200 response"
                  });
            }
        } catch (e) {
            this.setState({
                ...this.state,
                connectionStatusMessage: "Error " + e.message + ". Is the client running?"
              });
        }
        
        
        
        
    }

    handleCommandFieldChange(e) {
        this.setState({
            ...this.state,
            currentCommand: e.target.value
          });
    }

    async handleSendCommand() {
        const result = await axios.post(`http://127.0.0.1:${this.state.port}/command`, {
            commands: this.state.currentCommand.split(','),
          })

          if (result.status === 200) {
            this.setState({
                ...this.state,
                currentCommand: "",
                commandHistory: "> " + this.state.currentCommand + "\n" + this.state.commandHistory 
              });
          }
    }

    async handleStateRequest() {
        if (!this.state.connected) {
            return
        }

        const result = await axios.get(`http://127.0.0.1:${this.state.port}/state`)

        if (result.status === 200) {
            this.setState({
                ...this.state,
                printerState: result.data.state,
                lastStateFetchTime: Date().toLocaleString()
              });
        }



    }


    componentDidMount() {
        this.interval = setInterval(this.handleStateRequest, 2000);
      }

      componentWillUnmount() {
        clearInterval(this.interval);
      }




    render(){
    
      return (
        <Grid container spacing={3}>

            
            <Grid item xs={3}></Grid>
            <Grid  item xs={6}>
                <h2>Step 1: Select Allevi Client Port</h2>
                <p>This step confirms that this UI can ping the desktop allevi client at http://127.0.0.1:{this.state.confirmedPort}/ping</p>
                <TextField fullWidth={true} id="text-read-configuration" onChange={this.handlePortFieldChange} label="Allevi Client Port (default: 8000)" variant="outlined" value={this.state.port} />
                <br/><br/>
                <Button fullWidth={true} variant="contained" onClick={this.handleConnectClick}>{this.state.connected ? "Disconnect" : "Connect"}</Button>
                <p>{this.state.connectionStatusMessage}</p>
                
            </Grid>
            <Grid item xs={3}></Grid>



     

            <Grid item xs={1}></Grid>



            <Grid  item xs={10}>
                <h2>Step 2: Communicate with printer</h2>
                <Grid container spacing={3}>
                    <Grid  item xs={6}>
                        <h3>Commands</h3>
                        <TextField fullWidth={true} id="command-field" onChange={this.handleCommandFieldChange} label="Enter Command (comma separated)" variant="outlined" value={this.state.currentCommand} />
                        <br/><br/>
                        <Button fullWidth={true} variant="contained" disabled={!this.state.connected} onClick={this.handleSendCommand}>Send Command</Button>
                        <h3>Command History</h3>
                        <TextField fullWidth={true} id="command-history-field" label="Command History" variant="outlined" multiline rows={11} value={this.state.commandHistory} />
                    </Grid>
                    <Grid  item xs={6}>
                        <h3>State</h3>
                        <TextField fullWidth={true} id="state-field" variant="outlined" multiline rows={20} value={JSON.stringify(this.state.printerState)} />
                        <p>{this.state.lastStateFetchTime}</p>
                    </Grid>
                </Grid>
            </Grid>



        

            <Grid item xs={1}></Grid>




     
        </Grid>
      );
    }
}


